<script lang="ts">
    import Fa from 'svelte-fa'
    import { faImages, faPen, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'
    import { DEFAULT_MARKER_TOOLS, type MarkerToolConfig } from '../types/marker-types'

    export let data: Record<string, any>

    if (!data.markerTypes || data.markerTypes.length === 0) {
        data.markerTypes = DEFAULT_MARKER_TOOLS.map((tool) => ({ ...tool }))
    }

    const shapeOptions: { value: MarkerToolConfig['shape']; label: string }[] = [
        { value: 'dot', label: 'Círculo' },
        { value: 'arrow', label: 'Seta' },
    ]

    function addTool() {
        data.markerTypes = [
            ...data.markerTypes,
            { id: crypto.randomUUID(), label: `Ferramenta ${data.markerTypes.length + 1}`, color: '#4263eb', unit: 'un', shape: 'dot' },
        ]
    }

    function removeTool(index: number) {
        data.markerTypes = data.markerTypes.filter((_: MarkerToolConfig, i: number) => i !== index)
    }
</script>

<div class="block-preview">
    <div class="preview-header">
        <Fa icon={faImages} />
        <span>Upload de fotos com marcação (lápis e borracha)</span>
        <Fa icon={faPen} class="pen-icon" />
    </div>

    <div class="tools-list">
        <span class="tools-title">Ferramentas da barra de marcação</span>
        {#each data.markerTypes as toolItem, index (toolItem.id)}
            <div class="tool-row">
                <input type="color" class="tool-color" bind:value={toolItem.color} title="Cor" />
                <input type="text" class="tool-label" bind:value={toolItem.label} placeholder="Nome da ferramenta" />
                <input type="text" class="tool-unit" bind:value={toolItem.unit} placeholder="Unid." maxlength="6" title="Unidade (ex: mm, un, ml)" />
                <select class="tool-shape" bind:value={toolItem.shape} title="Formato desenhado">
                    {#each shapeOptions as option (option.value)}
                        <option value={option.value}>{option.label}</option>
                    {/each}
                </select>
                {#if data.markerTypes.length > 1}
                    <button type="button" class="tool-remove" title="Remover" on:click={() => removeTool(index)}>
                        <Fa icon={faXmark} size="xs" />
                    </button>
                {/if}
            </div>
        {/each}
        <button type="button" class="add-tool" on:click={addTool}>
            <Fa icon={faPlus} size="xs" />
            <span>Adicionar ferramenta</span>
        </button>
    </div>
</div>

<style>
    .block-preview {
        max-width: 460px;
    }
    .preview-header {
        height: 64px;
        border: 1px dashed #c7cdd4;
        border-radius: 8px;
        background: #f8f9fa;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        color: #868e96;
        font-size: 0.85rem;
        padding: 0 16px;
    }
    :global(.pen-icon) {
        opacity: 0.6;
    }
    .tools-list {
        margin-top: 12px;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .tools-title {
        font-size: 0.78rem;
        color: #868e96;
        margin-bottom: 2px;
    }
    .tool-row {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .tool-color {
        width: 28px;
        height: 28px;
        padding: 0;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        cursor: pointer;
        flex-shrink: 0;
    }
    .tool-label {
        flex: 1;
        min-width: 0;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        padding: 5px 8px;
        font-size: 0.85rem;
    }
    .tool-label:focus {
        outline: none;
        border-color: var(--cs2-accent, #4263eb);
    }
    .tool-unit {
        width: 56px;
        flex-shrink: 0;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        padding: 5px 6px;
        font-size: 0.85rem;
    }
    .tool-unit:focus {
        outline: none;
        border-color: var(--cs2-accent, #4263eb);
    }
    .tool-shape {
        flex-shrink: 0;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        padding: 5px 6px;
        font-size: 0.85rem;
        background: #fff;
    }
    .tool-remove {
        flex-shrink: 0;
        border: none;
        background: transparent;
        color: #adb5bd;
        cursor: pointer;
        padding: 4px;
    }
    .tool-remove:hover {
        color: #fa5252;
    }
    .add-tool {
        display: flex;
        align-items: center;
        gap: 6px;
        border: none;
        background: transparent;
        color: #868e96;
        font-size: 0.85rem;
        padding: 4px 0;
        cursor: pointer;
        align-self: flex-start;
    }
    .add-tool:hover {
        color: var(--cs2-accent, #4263eb);
    }
</style>
